// @flow

import ReactDOM from 'react-dom';
import React from 'react';
import MemoryGame from './MemoryGame';

document.querySelectorAll('.memory-game').forEach(($memoryGame) => {
  const $scriptElement = $memoryGame.querySelector('.memory-game__data');
  const $rootElement = $memoryGame.querySelector('.js-memory-game');

  if ($scriptElement && $rootElement) {
    const data = JSON.parse($scriptElement.innerHTML);

    ReactDOM.render(
      <MemoryGame defaultImage={data.defaultImage} images={data.files} />,
      $rootElement,
    );
  }
});
